import { useState } from "react";
import { ChevronRightIcon, PlusCircleIcon } from "../../icons";
import BeneficiaryListItem from "./BeneficiaryListItem";
// import EmptyBeneficiaries from "../../../components/Empty/EmptyCryptoBeneficiaries";

const BeneficiaryListPanel = ({
  beneficiaries = [],
  selectedId,
  onSelect,
  onAddBeneficiary,
  onPageBack,
  isMobile = false,
}) => {
  const [searchQuery, setSearchQuery] = useState("");

  // Filter list by name or wallet address (case-insensitive)
  const filteredBeneficiaries = beneficiaries.filter((b) => {
    const query = searchQuery.toLowerCase().trim();
    const nameMatch = b.beneficiary_legal_name?.toLowerCase().includes(query) 
    || b.beneficiary_first_name?.toLowerCase().includes(query)
    || b.beneficiary_last_name?.toLowerCase().includes(query);
    const addressMatch = b.asset_id?.toLowerCase().includes(query);
    return nameMatch || addressMatch;
  });

  const listContent = (
    <div className="flex w-full flex-col gap-3">
      
      {/* Add Beneficiary Button */}
      <button
        type="button"
        onClick={onAddBeneficiary}
        className="flex h-16 w-full shrink-0 items-center rounded-[8px] border border-solid border-divider bg-background-alt px-[14px] py-[15px] custom-transition hover:bg-option-hover"
      >
        <div className="flex items-center gap-1">
          <PlusCircleIcon />
          <span className="text-sm font-semibold leading-normal text-[#4ab932]">
            Add Beneficiary
          </span>
        </div>
      </button>
      
      {/* Search Input */}
      <div className="relative w-full">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search by name or address..."
          className="w-full rounded-[8px] border border-solid border-divider bg-background-alt px-3.5 py-2.5 text-sm text-text-primary placeholder:text-text-secondary focus:ring-0 focus:border-[#4ab932] focus:outline-none"
        />
        {searchQuery && (
          <button
            type="button"
            onClick={() => setSearchQuery("")}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-text-secondary hover:text-text-primary"
          >
            Clear
          </button>
        )}
      </div>

      {/* Beneficiary List */}
      <div className="flex flex-col gap-1  overflow-y-scroll max-h-[calc(100dvh-20rem)] custom-scrollbar">
        {filteredBeneficiaries.length > 0 ? (
          filteredBeneficiaries.map((beneficiary) => (
            <BeneficiaryListItem
              key={beneficiary.id}
              beneficiary={beneficiary}
              isSelected={!isMobile && beneficiary.id === selectedId}
              onSelect={onSelect}
            />
          ))
        ) : (
          <div className="flex flex-1 flex-col items-center justify-center px-6 py-12 text-center">
            <h2 className="text-base font-semibold text-text-primary">
              No matching beneficiaries
            </h2>
            <p className="mt-1 text-sm text-text-secondary">
              We couldn't find any results for "{searchQuery}". Try checking the spelling or search using a different name or address.
            </p>
          </div>
        )}
      </div>
    </div>
  );

  if (isMobile) {
    return (
      <div className="flex w-full flex-col gap-5">
        <div className="relative flex items-center justify-center">
          <button
            type="button"
            onClick={onPageBack}
            className="absolute left-0 top-1/2 -translate-y-1/2 rounded-full p-0 custom-transition hover:bg-option-hover"
            aria-label="Go back"
          >
            <ChevronRightIcon className="rotate-180 text-text-secondary" />
          </button>
          <h1 className="text-base font-semibold leading-7 text-text-primary">
            Beneficiaries List
          </h1>
        </div>

        {listContent}
      </div>
    );
  }

  return (
    <div className="flex w-[500px] max-w-full shrink-0 flex-col gap-6">
      <p className="text-[20px] font-semibold leading-[28px] text-text-primary">
        Beneficiaries List
      </p>
      {listContent}
    </div>
  );
};

export default BeneficiaryListPanel;